import { IconCloseMS } from '@/constants/icons';
import { TabContext, TabPanel } from '@mui/lab';

import { SectionClient } from '../../Tabs/Clients/SectionClient';
import { Button } from '../Button';
import { TabsHeader } from './TabsHeader';
import { TabItem } from './types';

type TabsPanelProps = {
  tabs: TabItem[];
  selectedTab: string;
  onSelectedTabChange: (value: string) => void;
  onClose: (value: string) => void;
  onCloseAll: () => void;
  onActivityClick?: (id: number) => void;
};

export function TabsPanel({
  tabs,
  selectedTab,
  onSelectedTabChange,
  onClose,
  onCloseAll,
  onActivityClick,
}: TabsPanelProps): JSX.Element {
  const handleClose = (value: string): void => {
    if (selectedTab === value) {
      const remaining = tabs.filter((tab) => tab.value !== value);
      onSelectedTabChange(remaining[remaining.length - 1]?.value ?? '');
    }
    onClose(value);
  };

  return (
    <TabContext value={selectedTab}>
      {tabs.length > 1 ? (
        <TabsHeader
          tabs={tabs}
          onChange={onSelectedTabChange}
          onClose={handleClose}
          onCloseAll={onCloseAll}
        />
      ) : (
        <Button variant="text" onClick={onCloseAll}>
          {IconCloseMS}
        </Button>
      )}
      {tabs.map((tab) => (
        <TabPanel key={tab.value} value={tab.value}>
          <SectionClient
            id={tab.id.toString()}
            source={tab.source}
            onClose={() => handleClose(tab.value)}
            onActivityClick={onActivityClick}
          />
        </TabPanel>
      ))}
    </TabContext>
  );
}
